import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import api from "../../api/api";
import CircularProgress from "@mui/material/CircularProgress";
import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Button,
  FormControl,
  Box,
  Grid,
  IconButton,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
  Paper,
  Typography,
} from "@mui/material";
import Quiz from "../quiz_template/Quiz";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { DateField } from "@mui/x-date-pickers";
import RestoreIcon from "@mui/icons-material/Restore";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import moment from "moment/moment";
import {
  getAmazonPayThunk,
  createAmazonPayThunk,
  updateAmazonPayThunk,
  deleteAmazonPayThunk,
  tempDeleteAmazonPayThunk,
  restoreAmazonPayThunk,
  getDeletedListThunk,
} from "../AmazonPay/AmazonePayThunk";

const AmazonCreateVoucher = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, topicId, topicName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(topicId);
    setSelectedSkillsetName(topicName);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  const navigate_to = () => {
    navigate("/amazonpay");
  };

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [couponId, setCouponId] = useState("");
  const [showUpdate, setShowUpdate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [updateExtra, setUpdateExtra] = useState([]);
  const [data, setData] = useState([]);
  const [deletedData, setDeletedData] = useState([]);
  console.log("deletedData", deletedData);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cursorPosition, setCursorPosition] = useState(0);
  const inputRef = useRef(null);

  const handleInputChange = (index, field, value) => {
    let formattedValue = value;

    // if (field === "couponCode") {
    //   // Remove non-alphanumeric characters
    //   formattedValue = formattedValue.replace(/[^A-Z0-9]/gi, "");

    //   // Insert hyphens in the desired format
    //   if (formattedValue.length > 4) {
    //     formattedValue =
    //       formattedValue.slice(0, 4) +
    //       (formattedValue.length > 4 ? "-" + formattedValue.slice(4, 10) : "") +
    //       (formattedValue.length > 10
    //         ? "-" + formattedValue.slice(10, 14)
    //         : "");
    //   }
    // }

    const updatedVoucherDetails = [...voucherDetails];
    updatedVoucherDetails[index][field] = formattedValue;
    setVoucherDetails(updatedVoucherDetails);
  };

  const handleClose = () => {
    setShow(false);
    resetState();
  };

  const handleCancel = (index) => {
    const updatedVoucherDetails = [...voucherDetails];
    updatedVoucherDetails.splice(index, 1);
    setVoucherDetails(updatedVoucherDetails);
  };

  //------------------For getting Voucher Data--------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await dispatch(getAmazonPayThunk());
        setData(result.payload);
        console.log("result ===>", result.payload);
      } catch (error) {
        setError(error.message);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);
  //----------------------------------------------------------

  //--------------------For Creating Voucher-------------------
  const [voucherDetails, setVoucherDetails] = useState([
    {
      couponId: new Date().getTime().toString(),
      couponCode: "",
      amount: "",
      expireDate: "",
      uploadedBy: "admin@thinkzone.in",
      updatedBy: "admin@thinkzone.in",
    },
  ]);

  const handleAddVoucher = () => {
    setVoucherDetails([
      ...voucherDetails,
      {
        couponId: new Date().getTime(),
        couponCode: "",
        amount: "",
        expireDate: "",
        uploadedBy: "admin@thinkzone.in",
        updatedBy: "admin@thinkzone.in",
      },
    ]);
  };
  // console.log("voucherDetails---->", voucherDetails);
  const dataa = {
    couponsArr: voucherDetails,
  };

  const handleSave = () => {
    const isValid = voucherDetails.every(
      (voucher) =>
        voucher.couponCode.trim() !== "" &&
        voucher.amount !== "" &&
        voucher.expireDate !== ""
    );

    if (!isValid) {
      toast.error("Please fill in all fields for each voucher");
      return;
    }

    setShow(false);
    setIsLoading(true);

    // Update the updatedBy field for the existing voucher
    const updatedVoucherDetails = voucherDetails.map((voucher) => ({
      ...voucher,
      updatedBy: "admin@thinkzone.in",
    }));

    const dataa = {
      couponsArr: updatedVoucherDetails,
    };

    dispatch(createAmazonPayThunk(dataa))
      .then((action) => {
        const { status } = action.payload;

        if (status === 200) {
          toast.success("Created Successfully");
          return dispatch(getAmazonPayThunk());
        } else if (status === 204) {
          toast.info("No additional information to show.");
          setIsLoading(false);
          throw new Error("No Content");
        } else if (status === 500) {
          toast.error("Internal Server Error. Please try again later.");
          setIsLoading(false);
          throw new Error("Internal Server Error");
        } else if (status === 504) {
          toast.error("Gateway Timeout. Please try again later.");
          setIsLoading(false);
          throw new Error("Gateway Timeout");
        }
      })
      .then((result) => {
        const { status, data } = result.payload;

        if (status === 200) {
          setData(data);
          resetState();
          setIsLoading(false);
        } else if (status === 204) {
          toast.info("No additional data available.");
          setIsLoading(false);
        } else if (status === 500) {
          toast.error("Internal Server Error. Please try again later.");
          setIsLoading(false);
        } else if (status === 504) {
          toast.error("Gateway Timeout. Please try again later.");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error handling voucher:", error);
        toast.error("Failed to update data. Please try again.");
        setIsLoading(false);
      });
  };

  // console.log("voucherDetails------------------->", voucherDetails);

  //------------------------------------------------------------

  //-----------------For Update Voucher--------------
  const [updateData, setUpdateData] = useState({
    couponId: "",
    couponCode: "",
    amount: "",
    expireDate: "",
    // updatedOn: new Date().getTime().toString(),
    updatedBy: "admin@thinkzone.in",
    uploadedBy: "admin@thinkzone.in",
  });
  //console.log("updateData-->", updateData);

  const handleShowUpdate = (eachskill) => {
    setUpdateExtra(eachskill);
    setUpdateData({
      couponCode: eachskill.couponCode,
      amount: eachskill.amount,
      expireDate: eachskill.expireDate,
      uploadedBy: "admin@thinkzone.in",
      updatedBy: "admin@thinkzone.in",
      couponId: eachskill.couponId,
      // updatedOn: new Date().getTime().toString(),
    });
    setShowUpdate(true);
  };

  const [validation, setValidation] = useState({
    couponCode: true,
    amount: true,
    expireDate: true,
  });
  const handleUpdateChanges = () => {
    // Perform validation
    const isCouponCodeValid = updateData.couponCode.trim() !== "";
    const isAmountValid = !isNaN(updateData.amount);
    const isExpireDateValid = updateData.expireDate !== "";

    // Update validation state
    setValidation({
      couponCode: isCouponCodeValid,
      amount: isAmountValid,
      expireDate: isExpireDateValid,
    });

    // Check if all fields are valid
    if (isCouponCodeValid && isAmountValid && isExpireDateValid) {
      dispatch(updateAmazonPayThunk(updateData))
        .then(() => {
          dispatch(getAmazonPayThunk()).then((result) => {
            setData(result.payload);
          });
          toast.success("Updated successfully");
        })
        .catch((err) => {
          console.error(err);
          toast.error("Enter a valid field");
        });

      setShowUpdate(false);
    } else {
      toast.error("Please fill in all required fields.");
    }
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };
  const handleEditModal = () => {
    setLoading(true);
    dispatch(getDeletedListThunk())
      .then((result) => {
        console.log("result", result);
        setDeletedData(result.payload);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          console.log("Data not found");
          // Handle 404 error (Not Found) here
        } else {
          console.log("An error occurred");
          // Handle other errors here
        }
      })
      .finally(() => {
        setLoading(false);
        setShowEdit(true);
      });
  };
  const handleCloseEdit = () => {
    setShowEdit(false);
  };
  //-----------------------------------------------------------
  //--------------------------Restore Vouture------------------

  const restore_button_click = (couponId) => {
    setShowEdit(false);
    Swal.fire({
      title: "Are you sure?",
      text: "You Want to Restore the Coupon",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#0000FF",
      confirmButtonText: "Yes, restore it!",
    }).then((result) => {
      // Perform validation
      if (result.isConfirmed) {
        const isCouponCodeValid = updateData.couponCode.trim() !== "";
        const isAmountValid = !isNaN(updateData.amount);
        const isExpireDateValid = updateData.expireDate !== "";

        // Update validation state
        setValidation({
          couponCode: isCouponCodeValid,
          amount: isAmountValid,
          expireDate: isExpireDateValid,
        });

        const body2 = {
          couponId: couponId,
          updatedBy: "admin@thinkzone.in",
        };
        // Check if all fields are valid
        dispatch(restoreAmazonPayThunk(body2))
          .then(() => {
            dispatch(getAmazonPayThunk()).then((result) => {
              setData(result.payload);
            });
            toast.success("Updated successfully");
          })
          .catch((err) => {
            console.error(err);
            toast.error("Enter a valid field");
          });
      }
    });
  };
  //-----------------------------------------------------------

  //----------------------For Delete Voucher-------------------
  const delete_content_button_click = (couponId) => {
    setShowEdit(false);
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const body = {
          couponId: couponId,
          updatedBy: "admin@thinkzone.in",
        };
        dispatch(tempDeleteAmazonPayThunk(body))
          .then((res) => {
            toast.success(res?.payload?.msg);
            dispatch(getAmazonPayThunk()).then((result) => {
              setData(result?.payload);
            });
          })
          .catch((error) => {
            console.error("Error deleting coupon:", error);
            if (error.status === 500) {
              toast.error("Failed to delete data: Coupon not found");
            } else if (error.status === 200) {
              toast.error("Unexpected success: Failed to delete data");
            } else {
              toast.error("Failed to delete data");
            }
          });
      }
    });
  };

  const delete_permantent_button_click = (couponId) => {
    console.log("couponId-->", couponId);
    setShowEdit(false);
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteAmazonPayThunk(couponId))
          .then(async () => {
            toast.error("Deleted successfully");
            const result = await dispatch(getAmazonPayThunk());
            setData(result.payload);
            setShowEdit(false);
          })
          .catch((error) => {
            console.error("Error deleting coupon:", error);
            if (error.status === 500) {
              toast.error("Failed to delete data: Coupon not found");
            } else if (error.status === 200) {
              toast.error("Unexpected success: Failed to delete data");
            } else if (error.status === 504) {
              toast.error("Unexpected success: Failed to delete data");
            } else {
              toast.error("Failed to delete data");
            }
          });
      }
    });
  };
  //-----------------------------------------------------------

  const resetState = () => {
    setVoucherDetails([
      {
        couponId: new Date().getTime().toString(),
        couponCode: "",
        amount: "",
        expireDate: "",
        uploadedBy: "admin@thinkzone.in",
      },
    ]);
  };

  const handleCouponCodeChange = (e) => {
    let formattedValue = e.target.value;

    // // Remove non-alphanumeric characters
    // formattedValue = formattedValue.replace(/[^A-Z0-9]/gi, "");

    // // Insert hyphens in the desired format
    // if (formattedValue.length > 4) {
    //   formattedValue =
    //     formattedValue.slice(0, 4) +
    //     (formattedValue.length > 4 ? "-" + formattedValue.slice(4, 10) : "") +
    //     (formattedValue.length > 10 ? "-" + formattedValue.slice(10, 14) : "");
    // }

    setUpdateData({
      ...updateData,
      couponCode: formattedValue,
    });

    // Remove error message when user starts typing
    setValidation({
      ...validation,
      couponCode: true,
    });
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setUpdateData({
      ...updateData,
      amount: parseInt(value), // Handle non-numeric input
    });

    // Remove error message when user starts typing
    setValidation({
      ...validation,
      amount: true,
    });
  };

  const handleExpireDateChange = (e) => {
    const value = e.target.value;
    setUpdateData({
      ...updateData,
      expireDate: value,
    });

    // Remove error message when user starts typing
    setValidation({
      ...validation,
      expireDate: true,
    });
  };
  console.log("updateData---------------------->", updateData);

  return (
    <>
      <div>
        <MuiHeader header="Leaderboard and Coin redeem Voucher" />
        {/* -------------------------Create Voucher Button------------------- */}
        <FormControl
          style={{
            position: "absolute",
            padding: "20px",
          }}
          size="small"
        >
          <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            <Button
              sx={{
                backgroundColor: "blue",
              }}
              variant="contained"
              onClick={handleShow}
            >
              Create Voucher
            </Button>
            <Button
              onClick={handleEditModal}
              variant="contained"
              sx={{
                // minWidth: 80,
                // alignItem: "right",
                backgroundColor: "blue",
                color: "white",
                marginLeft: "700px",
              }}
              size="small"
            >
              <EditIcon style={{ color: "white" }}></EditIcon>
              Deleted Coupon List
            </Button>
            <Button
              onClick={navigate_to}
              variant="contained"
              sx={{
                // minWidth: 80,
                // alignItem: "right",
                backgroundColor: "blue",
                color: "white",
                marginLeft: "10px",
              }}
              size="small"
            >
              <UndoIcon style={{ color: "orange" }}></UndoIcon>
              Back
            </Button>
          </div>
        </FormControl>

        {/* --------------------Showing Voucher Data in table ------------------ */}
        {data && data?.length > 0 ? (
          <Paper style={{ width: 800, marginTop: 180 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "60px" }}> SerialNo. </TableCell>
                  <TableCell style={{ width: "210px", paddingLeft: "30px" }}>
                    Voucher
                  </TableCell>
                  {/* <TableCell style={{ width: "210px", paddingLeft: "30px" }}>
                    Voucher ID
                  </TableCell> */}
                  <TableCell style={{ width: "170px", paddingLeft: "80px" }}>
                    Amount
                  </TableCell>
                  <TableCell style={{ width: "120px", paddingLeft: "80px" }}>
                    Expiry Date
                  </TableCell>
                  <TableCell style={{ paddingLeft: "120px" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              {data?.map((eachskill, index) => (
                <TableBody key={index}>
                  <TableRow>
                    <TableCell style={{ width: "100px" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell style={{ width: "180px", paddingLeft: "30px" }}>
                      {eachskill.couponCode}
                    </TableCell>{" "}
                    {/* <TableCell style={{ width: "180px", paddingLeft: "30px" }}>
                      {eachskill.couponId} */}
                    {/* </TableCell>{" "} */}
                    <TableCell style={{ width: "100px", paddingLeft: "80px" }}>
                      {eachskill.amount}
                    </TableCell>{" "}
                    <TableCell style={{ width: "100px", paddingLeft: "95px" }}>
                      {" "}
                      {/* {eachskill.expireDate} */}
                      {moment(eachskill.expireDate).format("DD/MM/YY")}
                    </TableCell>
                    <TableCell
                      style={{
                        width: -20,
                        paddingLeft: "-130px",
                        marginLeft: "-120px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          style={{ marginLeft: 65 }}
                          onClick={() => handleShowUpdate(eachskill)}
                        >
                          <EditIcon style={{ color: "blue" }}></EditIcon>
                        </Button>
                        <Button
                          onClick={() =>
                            delete_content_button_click(eachskill.couponId)
                          }
                        >
                          <DeleteIcon style={{ color: "red" }}></DeleteIcon>
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ))}
            </Table>
          </Paper>
        ) : null}
        {/* --------------------------------------------------------------------- */}
        {/* --------------------Create Voucher Modal Open---------------------- */}
        <Modal
          open={show}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ maxHeight: "600px", scrollBehavior: "auto" }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 800,
              bgcolor: "background.paper",
              boxShadow: 24,
              padding: 4,
              maxHeight: "500px",
              overflowY: "auto",
            }}
          >
            <div>
              {voucherDetails.map((couponCode, index) => (
                <>
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      marginBottom: 16,
                    }}
                  >
                    <FormControl fullWidth style={{ flex: 1, marginRight: 16 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            id={`couponCode-${index}`}
                            label="(XXXX-XXXXXX-XXXX)"
                            variant="outlined"
                            size="small"
                            value={couponCode.couponCode}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "couponCode",
                                e.target.value
                              )
                            }
                          />
                        </Grid>
                      </Grid>
                    </FormControl>
                    <FormControl fullWidth style={{ flex: 1, marginRight: 16 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            id={`amount-${index}`}
                            label="Enter Amount"
                            variant="outlined"
                            size="small"
                            type="number"
                            value={couponCode.amount}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "amount",
                                parseInt(e.target.value)
                              )
                            }
                          />
                        </Grid>
                      </Grid>
                    </FormControl>
                    <FormControl fullWidth style={{ flex: 1 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <input
                            type="date"
                            value={couponCode.expireDate}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "expireDate",
                                e.target.value
                              )
                            }
                            style={{ height: "40px", width: "180px" }}
                          />
                        </Grid>
                      </Grid>
                    </FormControl>
                    {/* <IconButton
                      variant="contained"
                      onClick={() => handleCancel(index)}
                      style={{
                        // marginTop: 8,
                        backgroundColor: "white",
                      }}
                    >
                      <CloseIcon
                        style={{ color: "red", marginTop: -5 }}
                      ></CloseIcon>
                    </IconButton> */}
                  </div>
                </>
              ))}
              {/* <Button
                variant="contained"
                onClick={handleAddVoucher}
                style={{
                  marginRight: -14,
                  backgroundColor: "#2196f3",
                  color: "#fff",
                }}
              >
                Add
              </Button> */}
              <br />
            </div>
            <div
              sx={{
                // mt: 2,

                display: "flex",
                justifyContent: "space-between",
                top: "330px",
              }}
            >
              <Button
                variant="outlined"
                onClick={handleClose}
                style={{ margin: 10 }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: 10 }}
                onClick={handleSave}
              >
                Save
              </Button>
            </div>
          </Box>
        </Modal>
        {/* --------------------Create Voucher Modal Close---------------------- */}
        {/* --------------------Update Voucher Modal Open---------------------- */}
        <Modal
          open={showUpdate}
          onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} style={{ marginTop: 1 }}>
                  <Grid item xs={12}>
                    <TextField
                      id="outlined-basic"
                      label="Enter Voucher"
                      style={{ width: "140px" }}
                      variant="outlined"
                      value={updateData.couponCode}
                      onChange={handleCouponCodeChange}
                      error={!validation.couponCode}
                      helperText={
                        !validation.couponCode && "Coupon Code is required"
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Amount"
                      variant="outlined"
                      type="number"
                      value={updateData.amount}
                      // onChange={(e) =>
                      //   setUpdateData({
                      //     ...updateData,
                      //     amount: parseInt(e.target.value),
                      //   })
                      // }
                      onChange={handleAmountChange}
                      error={!validation.amount}
                      helperText={!validation.amount && "Amount is required"}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <input
                      type="date"
                      id="expireDate"
                      value={
                        updateData.expireDate
                          ? moment(updateData.expireDate).format("YYYY-MM-DD")
                          : ""
                      }
                      onChange={handleExpireDateChange}
                      min={moment().format("YYYY-MM-DD")}
                      max={moment().add(1, "year").format("YYYY-MM-DD")}
                      required
                      style={{
                        height: "50px",
                        width: "180px",
                        marginTop: "5px",
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            <Button variant="contained" onClick={handleUpdateChanges}>
              Update
            </Button>
          </Box>
        </Modal>
        {/* --------------------Create Voucher Modal Close---------------------- */}

        <Modal
          open={showEdit}
          onClose={handleCloseEdit}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "white",
              // width: "60%",
              maxHeight: "80vh",
              overflowY: "auto",
              p: 2,
              borderRadius: 4,
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {loading ? (
              <CircularProgress />
            ) : (
              <>
                {deletedData?.length > 0 ? (
                  <Table>
                    <TableHead>
                      <TableRow
                        style={{
                          position: "sticky",
                          top: -19,
                          zIndex: 1000,
                          backgroundColor: "white",
                        }}
                      >
                        <TableCell>Serial No.</TableCell>
                        <TableCell>Voucher</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Expiry Date</TableCell>
                        <TableCell>Restore</TableCell>
                        <TableCell>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {deletedData.length > 0 &&
                        deletedData?.map((eachskill, index) => (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{eachskill?.couponCode}</TableCell>
                            <TableCell>{eachskill?.amount}</TableCell>
                            <TableCell>
                              {moment(eachskill?.expireDate).format("DD/MM/YY")}
                            </TableCell>
                            <TableCell>
                              <div>
                                <Button
                                  onClick={() =>
                                    restore_button_click(eachskill?.couponId)
                                  }
                                >
                                  <RestoreIcon />
                                </Button>
                              </div>
                            </TableCell>
                            <TableCell>
                              <Button
                                onClick={() =>
                                  delete_permantent_button_click(
                                    eachskill?.couponId
                                  )
                                }
                              >
                                <DeleteForeverIcon style={{ color: "red" }} />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography
                    variant="h6"
                    align="center"
                    style={{ color: "gray" }}
                  >
                    No Deleted Data
                  </Typography>
                )}
              </>
            )}
          </Box>
        </Modal>
      </div>
      <ToastContainer />
    </>
  );
};

export default AmazonCreateVoucher;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
